// DataArrayNodeModal.js
import React, { useState } from 'react';

import Modal from '../base/Modal';

const DataArrayNodeModal = ({
  mode,
  nodeData,
  onSave,
  onDelete,
  onClose,
  viewOnly,
}) => {
  const [purpose, setPurpose] = useState(nodeData?.data?.purpose || '');
  const [elementDetails, setElementDetails] = useState(
    nodeData?.data?.elementDetails || '',
  );

  const handleSave = () => {
    const updatedNode = {
      ...nodeData,
      data: {
        ...(nodeData?.data || {}),
        purpose,
        elementDetails,
      },
    };
    onSave(updatedNode);
  };

  return (
    <Modal
      title={
        viewOnly
          ? 'Data Array Node'
          : mode === 'add'
            ? 'Add Data Array Node'
            : 'Edit Data Array Node'
      }
      isOpen={true}
      onClose={onClose}
    >
      <div className="overflow-auto rounded bg-zinc-800 p-6 text-zinc-100 shadow-lg">
        {/* Purpose Input */}
        <div className="mb-4">
          <label htmlFor="purpose" className="mb-1 block text-sm font-medium">
            Purpose
          </label>
          <textarea
            className="w-full rounded border border-zinc-600 bg-zinc-700 p-2 focus:outline-none focus:ring-2 focus:ring-[#5652CF]"
            placeholder="Describe the purpose for splitting the data (e.g., to generate individual email elements)."
            value={purpose}
            disabled={viewOnly}
            onChange={(e) => setPurpose(e.target.value)}
            rows={3}
          />
        </div>

        {/* Element Details Input */}
        <div className="mb-4">
          <label
            htmlFor="element-details"
            className="mb-1 block text-sm font-medium"
          >
            Element Details
          </label>
          <textarea
            className="w-full rounded border border-zinc-600 bg-zinc-700 p-2 focus:outline-none focus:ring-2 focus:ring-[#5652CF]"
            placeholder="Specify the complete structure each element must have (e.g., recipient, name, custom message, etc.)."
            value={elementDetails}
            disabled={viewOnly}
            onChange={(e) => setElementDetails(e.target.value)}
            rows={3}
          />
        </div>

        {/* Action Buttons */}
        {!viewOnly && (
          <div className="mt-4 flex justify-end gap-3">
            {mode === 'edit' && (
              <button
                className="rounded bg-zinc-700 px-4 py-2 text-zinc-300 hover:bg-zinc-600"
                onClick={() => onDelete(nodeData.id)}
              >
                Delete Node
              </button>
            )}
            <button
              className="rounded bg-zinc-700 px-4 py-2 text-zinc-300 hover:bg-zinc-600"
              onClick={handleSave}
            >
              {mode === 'add' ? 'Add Node' : 'Save Changes'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DataArrayNodeModal;
